/* Miss May I — Shopify Theme JS */

(function () {
  'use strict';

  /* ── Hero parallax ─────────────────────────────────────────── */
  var heroLogoWrap = document.querySelector('.hero-logo-wrap');
  if (heroLogoWrap) {
    window.addEventListener('scroll', function () {
      var viewportH = window.innerHeight * 0.9;
      var progress = Math.min(window.scrollY / viewportH, 1);
      var translateY = -140 * progress;
      var scale = 1 - 0.08 * progress;
      var opacity = 1 - 0.9 * progress;
      heroLogoWrap.style.transform =
        'translate(-50%, -50%) translateY(' + translateY + 'px) scale(' + scale + ')';
      heroLogoWrap.style.opacity = opacity.toFixed(3);
    }, { passive: true });
  }

  /* ── Reveal on scroll ──────────────────────────────────────── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.dataset.revealDelay || 0;
          setTimeout(function () { el.classList.add('revealed'); }, delay * 1000);
          observer.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -80px 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('revealed'); });
  }

  /* ── Latest video player ───────────────────────────────────── */
  var videoSection = document.querySelector('.latest-video-container');
  if (videoSection) {
    var artIframe = videoSection.querySelector('.art-iframe');
    var playerIframe = videoSection.querySelector('.player-iframe');
    var lionsLoader = videoSection.querySelector('.video-lion-loader');
    var overlay = videoSection.querySelector('.video-overlay');

    // Fade in art iframe after 5s
    if (artIframe) {
      setTimeout(function () { artIframe.classList.add('art-visible'); }, 5000);
    }

    // Play button click
    if (overlay) {
      overlay.addEventListener('click', function () {
        if (artIframe) { artIframe.style.opacity = '0'; }
        if (lionsLoader) { lionsLoader.style.display = 'none'; }
        if (playerIframe) { playerIframe.classList.add('active'); }
        overlay.style.display = 'none';
      });
    }
  }

  /* ── Phone status bar time ─────────────────────────────────── */
  var phoneTime = document.querySelector('.phone-status-time');
  if (phoneTime) {
    function updateTime() {
      var now = new Date();
      var h = now.getHours() % 12 || 12;
      var m = String(now.getMinutes()).padStart(2, '0');
      phoneTime.textContent = h + ':' + m;
    }
    updateTime();
    setInterval(updateTime, 60000);
  }

  /* ── External links open in a new tab ──────────────────────── */
  function markExternalLink(link) {
    if (!(link instanceof HTMLAnchorElement) || link.dataset.externalLinkChecked) return;
    link.dataset.externalLinkChecked = 'true';

    var href = link.getAttribute('href') || '';
    if (!href || href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 ||
        href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) {
      return;
    }

    if (link.origin && link.origin !== window.location.origin) {
      link.setAttribute('target', '_blank');
      var rel = (link.getAttribute('rel') || '').split(' ').filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      link.setAttribute('rel', rel.join(' '));
    }
  }

  function scanForExternalLinks(root) {
    root.querySelectorAll('a[href]').forEach(markExternalLink);
  }

  scanForExternalLinks(document);

  // Catch links added later (AJAX cart, search results, quick add modals, etc.)
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) markExternalLink(node);
          if (node.querySelectorAll) scanForExternalLinks(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ── Phone game video autoplay ─────────────────────────────── */
  var phoneVideo = document.querySelector('.phone-video');
  if (phoneVideo) {
    phoneVideo.muted = true;
    phoneVideo.loop = true;
    phoneVideo.playsInline = true;
    var playPhone = function () { phoneVideo.play().catch(function () {}); };
    playPhone();
    var onPhoneInteract = function () {
      playPhone();
      document.removeEventListener('touchstart', onPhoneInteract);
      document.removeEventListener('click', onPhoneInteract);
    };
    document.addEventListener('touchstart', onPhoneInteract, { once: true });
    document.addEventListener('click', onPhoneInteract, { once: true });
  }

})();
